// extracted by mini-css-extract-plugin
module.exports = {"description":"TwelveWeek_description__pdlGQ"};